const theme = {
  colors: {
    primary: {
      green: '#8fff86',
      blue: '#4d81ee',
      red: '#e14f62',
      yellow: '#e1b84f',
      purple: '#845eee',
      aqua: '#91d1f8',
    },
    background: {
      dark: '#0f0f0f',
      light: '#ffffff',
    },
    text: {
      primary: '#e2e8f0',
      secondary: '#cbd5e1',
      aqua: '#91d1f8',
    },
  },
};

export default theme;
